import { Typography, Button } from "@mui/material";
import { useTriggerSettlementMutation } from "Api/Mutations/Settlements/useTriggerSettlementMutation";
import { toast } from "sonner";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

export const SettlementPageContent = () => {
  const { t } = useResource();
  const { mutate: triggerSettlement, isPending } =
    useTriggerSettlementMutation();

  const handleTriggerSettlement = () => {
    triggerSettlement(undefined, {
      onSuccess: () => {
        toast.success(
          t(Resources.Pages.Content.Settlements.SettlementTriggerSuccess),
        );
      },
      onError: () => {
        toast.error(
          t(Resources.Pages.Content.Settlements.SettlementTriggerError),
        );
      },
    });
  };

  return (
    <PrimaryPaper>
      <Typography>
        {t(Resources.Pages.Content.Settlements.SettlementTrigger)}
      </Typography>
      <Button
        sx={{ marginTop: 4 }}
        variant="contained"
        onClick={handleTriggerSettlement}
        disabled={isPending}
      >
        {isPending
          ? t(Resources.Pages.Content.Settlements.SettlementTriggerLoading)
          : t(Resources.Pages.Content.Settlements.SettlementTriggerButtonText)}
      </Button>
    </PrimaryPaper>
  );
};
